import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import { getUserSession } from "../../../util/core/Session";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";

function Form() {
  const session = getUserSession();
  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const { id } = useParams();

  const path = "/core/applicationsfunctionalities/";
  const paths = {
    endpointSave: config.endpoints.backend + "core/applicationsfunctionalities/save",
    endpointGetById: config.endpoints.backend + "core/applicationsfunctionalities/getById",
    urlGoBack: path + "list",
    pathView: path + "view",
  };

  const labels = {
    labelTitleAdd: "Nova Funcionalidade",
    labelTitleEdit: "Editar Funcionalidade",
    labelTitleView: "Visualizar Funcionalidade",
  };

  const getForm = (values) => {
    let form = {
      validateOnChange: true,
      hiddenValues: {
        core_user_id: session.user.id,
      },
      fields: [
        {
          name: "functionality",
          type: "text",
          label: "Funcionalidade",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: 'icon',
          type: 'selectIcons',
          label: 'Ícone',
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "path",
          type: "text",
          label: "Path",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "prefix",
          type: "text",
          label: "Prefixo (parte que não muda do path)",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
      ],
      ...paths,
      ...labels,
    };
    form.values = values;
    return form;
  };

  useEffect(() => {
    const load = async () => {
      let values = {};
      if (id) {
        values = await Fetch.post(paths.endpointGetById, { id: id });
      }else{
        values = {actions: [
            {action: {label: 'Criar', value: 'Create'}},
            {action: {label: 'Atualizar', value: 'Update'}},
            {action: {label: 'Apagar', value: 'Delete'}},
            {action: {label: 'Download', value: 'Download'}},
        ]}
      }
      const form = getForm(values);
      setFormContent(
        <CustomFormContainer form={form} content={<CustomForm form={form} />} />
      );
    };
    load();
  }, []);

  return <div>{formContent}</div>;
}
export default Form;